import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import DateInput from './DateInput';

export default function DateRangeFilter({ dateFrom, dateTo, onDateFromChange, onDateToChange, onRefresh }) {
  const { t } = useLanguage();

  const handleDateFromChange = (val) => {
    onDateFromChange(val);
    if (dateTo && val && val > dateTo) {
      onDateToChange(val);
    }
  };

  const handleDateToChange = (val) => {
    onDateToChange(val);
    if (dateFrom && val && val < dateFrom) {
      onDateFromChange(val);
    }
  };

  return (
    <>
      <div className="filter-group">
        <label className="filter-label">{t('common.from')}</label>
        <DateInput
          className="filter-input"
          value={dateFrom}
          max={dateTo || undefined}
          onChange={handleDateFromChange}
        />
      </div>
      <div className="filter-group">
        <label className="filter-label">{t('common.to')}</label>
        <DateInput
          className="filter-input"
          value={dateTo}
          min={dateFrom || undefined}
          onChange={handleDateToChange}
        />
      </div>
      {onRefresh && (
        <div className="filter-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
          <button
            type="button"
            className="btn-secondary btn-sm"
            title={t('common.refresh') || 'Refresh'}
            onClick={onRefresh}
            style={{ padding: '6px 10px', fontSize: 16, lineHeight: 1 }}
          >
            &#x21bb;
          </button>
        </div>
      )}
    </>
  );
}
